import { render, staticRenderFns } from "./Career.vue?vue&type=template&id=19765678&"
import script from "./Career.vue?vue&type=script&lang=js&"
export * from "./Career.vue?vue&type=script&lang=js&"
import style0 from "./Career.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
